import { useState } from 'react';
import { useIntl } from 'react-intl';

import { type ChatWindowProps } from '@verantos-dev/shared-components';
import { readFileAsBase64 } from '@verantos-dev/shared-utils';

interface ChatFilePayload {
  name: string;
  data: string;
  type: string;
  size: number;
}

export const useResearchAssistantFileUploadState = (): {
  fileUploadConfig: ChatWindowProps['fileUploadConfig'] | undefined;
  encodeFile: (file: File) => Promise<ChatFilePayload>;
} => {
  const [file, setFile] = useState<File | null>(null);
  const intl = useIntl();

  const encodeFile = async (file: File): Promise<ChatFilePayload> => ({
    name: file.name,
    data: await readFileAsBase64(file),
    type: file.type || 'csv',
    size: file.size,
  });

  return {
    encodeFile,
    fileUploadConfig: {
      accept: '.csv',
      selectedFile: file,
      onFileSelected: setFile,
      isDisabled: false,
      buttonAriaLabel: intl.formatMessage({
        id: 'projects.researchAssistant.chatWindow.fileUpload.buttonAriaLabel',
      }),
      selectedFileName: file?.name,
      onClearSelectedFile: () => setFile(null),
      maxFileSizeMB: 0.5,
    },
  };
};
